import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Button, PageHeader } from '../components'


const WelcomePage = ({ intl }) => (
  <div className="welcome-page flex-column items-center">
    <PageHeader
      center
      title={intl.formatMessage(messages.welcomeMsg)}
    />
    <div className="spacing-top flex-column items-center">
      <div>
        <Link id="welcome-create-test" to="/app/create-test">
          <Button positive big>
            {intl.formatMessage(messages.createTest)}
          </Button>
        </Link>
      </div>
      <p>{intl.formatMessage(messages.or)}</p>
      <div>
        <Link id="welcome-search-exercise" to="/app/search">
          <Button positive big>
            {intl.formatMessage(messages.searchCreatedexercises)}
          </Button>
        </Link>
      </div>
    </div>
  </div>
)

WelcomePage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(WelcomePage)

const messages = defineMessages({
  welcomeMsg: {
    id: 'welcome.page.welcomeMsg',
    defaultMessage: 'Vitajte. Vyberte si ďalší postup.',
  },
  createTest: {
    id: 'welcome.page.createTest',
    defaultMessage: 'Vytvoriť test s vlastnými cvičeniami',
  },
  or: {
    id: 'welcome.page.or',
    defaultMessage: 'alebo',
  },
  searchCreatedexercises: {
    id: 'welcome.page.searchCreatedexercises',
    defaultMessage: 'Vyhľadať pripravené cvičenia',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/WelcomePage.js